module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        return _vm.onClickEvent()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3132b29e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddScheduledCaseButton.vue
// module id = 947
// module chunks = 1